export default {
  BASE_URL: 'https://myle-19701.uc.r.appspot.com/',
  BASE_IMAGE_URL: 'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/',
  API_URL: 'https://myle-19701.uc.r.appspot.com',
  APP_NAME: 'myle',
  APP_TITLE: 'MYLE',
  APP_LOGO: '/img/myle/svg/logo.svg',
  GOOGLE_MAP_KEY: 'AIzaSyBQj_nbTJfbaDASK-IZbiuVztE82GUlddI',
  IOS_APP_DOWNLOAD_URL: 'https://apps.apple.com/us/app/myle-create-discover-events-curated-for-you/id1162354481',
  ANDROID_APP_DOWNLOAD_URL: 'https://play.google.com/store/apps/details?id=xyz.getmyle.myle&hl=en',
  APP_DEEP_LINK: 'myle://event='
}
